import { Web3ReactProvider } from "@web3-react/core";
import { getLibrary } from "./utils/wallet";
import { Box, CssBaseline, ThemeProvider } from "@mui/material";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { ColorModeContext, useMode } from "./theme";
import ConnectWallet from "./scenes/Wallet/ConnectWallet";
import { Routes } from "./routes";
import Snackbar from "./components/Snackbar";
import Layout from "./components/Layout";
import Topbar from "./scenes/global/Topbar";
import PermanentDrawerLeft from "./scenes/global/LeftDrawer";

function App() {
  const [theme, colorMode] = useMode();

  return (
    <Web3ReactProvider getLibrary={getLibrary}>
      <ColorModeContext.Provider value={colorMode}>
        <ThemeProvider theme={theme}>
          <DndProvider backend={HTML5Backend}>
            <Layout>
              <CssBaseline />
              <div className="app">
                <Snackbar />

                <div className="">
                  <PermanentDrawerLeft />
                </div>
                <main className="content">
                  <Box sx={{ marginTop: "24px" }}>
                    <Topbar />
                  </Box>
                  <Routes />
                </main>
              </div>
              <ConnectWallet />
            </Layout>
          </DndProvider>
        </ThemeProvider>
      </ColorModeContext.Provider>
    </Web3ReactProvider>
  );
}

export default App;
